import { Host, h } from "@stencil/core";
export class ChNotifications {
    constructor() {
        this.notificationsSize = 0;
        this.delayToAnimateNewNotifications = 50;
        this.notifications = [];
        this.position = "bottom-end";
        this.timeToDismissNotifications = 5000;
        this.timeType = "Milliseconds";
    }
    /**
     * `true` if the componentDidLoad lifecycle method was executed
     */
    didLoad = false;
    lastNotificationID = 0;
    currentNotifications = new Map();
    handleNewNotificationsChange(newNotifications) {
        // Sometimes StencilJS calls this decorator before the component did load
        if (this.didLoad) {
            this.addNewNotifications(newNotifications);
        }
    }
    handleNotificationClick(event) {
        const notification = this.currentNotifications.get(event.detail);
        if (!notification) {
            return;
        }
        if (notification.closeOnClick) {
            this.currentNotifications.delete(event.detail);
            // Trigger render
            this.notificationsSize--;
        }
    }
    handleNotificationDismiss(event) {
        this.currentNotifications.delete(event.detail);
        // Trigger render
        this.notificationsSize--;
    }
    addNewNotifications(notifications) {
        if (!notifications) {
            return;
        }
        let delayToAnimate = 0;
        notifications.forEach(notification => {
            const notificationID = notification.Id ?? this.lastNotificationID;
            // If the notification did not have an ID, increment the counter
            if (!notification.Id) {
                this.lastNotificationID++;
            }
            notification["id"] = notificationID;
            notification["delayToAnimate"] = delayToAnimate;
            this.currentNotifications.set(notificationID, notification);
            delayToAnimate++;
        });
    }
    getMessages = () => [...this.currentNotifications.values()];
    getTimeToDismiss = () => this.timeType === "Seconds"
        ? this.timeToDismissNotifications * 1000
        : this.timeToDismissNotifications;
    componentWillLoad() {
        this.addNewNotifications(this.notifications);
    }
    componentDidLoad() {
        this.didLoad = true;
    }
    render() {
        const messages = this.getMessages();
        return (h(Host, { tabindex: messages.length > 0 ? "0" : undefined, role: "alert", "aria-atomic": "true", class: `ch-notifications-position--${this.position}` }, messages.map(({ Id, Value, Class, delayToAnimate }) => (h("ch-notifications-item", { id: Id.toString(), key: Id, class: Class, style: {
                "--delay-to-animate": `${delayToAnimate * this.delayToAnimateNewNotifications}ms`
            }, "time-to-dismiss": this.getTimeToDismiss() +
                delayToAnimate * this.delayToAnimateNewNotifications, innerHTML: Value })))));
    }
    static get is() { return "ch-notifications"; }
    static get originalStyleUrls() {
        return {
            "$": ["notifications.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["notifications.css"]
        };
    }
    static get properties() {
        return {
            "delayToAnimateNewNotifications": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "delay-to-animate-new-notifications",
                "reflect": false,
                "defaultValue": "50"
            },
            "notifications": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "NotificationMessageWithDelay[]",
                    "resolved": "NotificationMessageWithDelay[]",
                    "references": {
                        "NotificationMessageWithDelay": {
                            "location": "import",
                            "path": "./notifications-types",
                            "id": "src/components/notifications/notifications-types.ts::NotificationMessageWithDelay"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "defaultValue": "[]"
            },
            "position": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"bottom-start\" | \"bottom-end\"",
                    "resolved": "\"bottom-end\" | \"bottom-start\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "position",
                "reflect": false,
                "defaultValue": "\"bottom-end\""
            },
            "timeToDismissNotifications": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "time-to-dismiss-notifications",
                "reflect": false,
                "defaultValue": "5000"
            },
            "timeType": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"Seconds\" | \"Milliseconds\"",
                    "resolved": "\"Milliseconds\" | \"Seconds\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "time-type",
                "reflect": false,
                "defaultValue": "\"Milliseconds\""
            }
        };
    }
    static get states() {
        return {
            "notificationsSize": {}
        };
    }
    static get watchers() {
        return [{
                "propName": "notifications",
                "methodName": "handleNewNotificationsChange"
            }];
    }
    static get listeners() {
        return [{
                "name": "notificationClick",
                "method": "handleNotificationClick",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "notificationDismiss",
                "method": "handleNotificationDismiss",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=notifications.js.map
